import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "licence"
const LicenceIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M18.75 15.75C19.164 15.75 19.5 16.086 19.5 16.5S19.164 17.25 18.75 17.25H5.25C4.836 17.25 4.5 16.914 4.5 16.5S4.836 15.75 5.25 15.75z" />
          <path
            fillRule="evenodd"
            d="M10.5 6.75C10.914 6.75 11.25 7.086 11.25 7.5V12.75C11.25 13.138 10.955 13.458 10.577 13.496L10.5 13.5H5.25L5.173 13.496C4.82 13.46 4.54 13.18 4.503 12.826L4.5 12.75V7.5C4.5 7.086 4.836 6.75 5.25 6.75zM6 12H9.75V8.25H6z"
            clipRule="evenodd"
          />
          <path d="M17.25 10.125C17.664 10.125 18 10.461 18 10.875S17.664 11.625 17.25 11.625H13.5C13.086 11.625 12.75 11.289 12.75 10.875S13.086 10.125 13.5 10.125zM18.75 7.5C19.164 7.5 19.5 7.836 19.5 8.25S19.164 9 18.75 9H13.5C13.086 9 12.75 8.664 12.75 8.25S13.086 7.5 13.5 7.5z" />
          <path
            fillRule="evenodd"
            d="M21 3.75C21.828 3.75 22.5 4.422 22.5 5.25V18.75C22.5 19.578 21.828 20.25 21 20.25H3C2.172 20.25 1.5 19.578 1.5 18.75V5.25C1.5 4.422 2.172 3.75 3 3.75zM3 18.75H21V5.25H3z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default LicenceIcon
